import { RouterState } from './router.type';
import { RouterActions, ROUTE_URL, CHANGE_LOCALE } from './router.actions.type';
import { getCurrentLocale } from '../../services/utils.service';

const defaultState: RouterState = {
  title: 'Urbano',
  showHeader: true,
  locale: getCurrentLocale() || 'es',
};

export default (state = defaultState, action: RouterActions): RouterState => {
  switch (action.type) {
    case ROUTE_URL: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case CHANGE_LOCALE: {
      return {
        ...state,
        locale: action.locale,
      };
    }

    default: {
      return state;
    }
  }
};
